// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1dOdZ","ranges":"BmiRanges_ranges__MJHm9"};